import React, { forwardRef } from 'react';
import styled from 'styled-components';

type OwnProps = React.SVGProps<SVGSVGElement>;

const ReductionTag = styled.svg`
  width: 16px;
  height: 16px;
  color: var(--cvna-color-blue-2);
  fill: var(--cvna-color-blue-2);

  &.green {
    color: var(--cvna-color-green-3);
    fill: var(--cvna-color-green-3);
  }

  &.white {
    width: 12px;
    height: 12px;
    color: var(--cvna-color-white);
    fill: var(--cvna-color-white);
  }
`;

const ReductionTagIcon = forwardRef<SVGSVGElement, OwnProps>((props, ref) => (
  <ReductionTag viewBox="0 0 16 16" ref={ref} {...props}>
    <path d="M16.5.87l-.41-.4c-.69-.7-3.93-.41-3.93-.41l-2,.25a3.66,3.66,0,0,0-1.61.9C6.85,2.93,1.8,8,.32,9.47A1,1,0,0,0,.38,11L6,16.59a1,1,0,0,0,1.49.06l8.26-8.26a3.78,3.78,0,0,0,.9-1.61c.08-.58.18-1.37.25-2C16.91,4.81,17.19,1.57,16.5.87ZM13.74,5.65a1.71,1.71,0,1,1,0-2.42A1.71,1.71,0,0,1,13.74,5.65Z" />
  </ReductionTag>
));

export default ReductionTagIcon;
